/*
 * @Author: youfanrong 737064439@qq.com
 * @Date: 2025-03-03 08:59:07
 * @LastEditors: youfanrong 737064439@qq.com
 * @LastEditTime: 2025-03-26 14:36:52
 * @FilePath: /bar-front-end/src/constants/index.ts
 */
/**
 * 请求成功状态码
 */
export const SUCCESS_CODE = 200

/**
 * 请求contentType
 */
export const CONTENT_TYPE: AxiosContentType = 'application/json'

/**
 * 请求超时时间
 */
export const REQUEST_TIMEOUT = 60000

/**
 * 不重定向白名单
 */
export const NO_REDIRECT_WHITE_LIST = ['/login', '/register']

/**
 * 不重置路由白名单
 */
export const NO_RESET_WHITE_LIST = ['Redirect', 'RedirectWrap', 'Login', 'NoFind', 'Root']

/**
 * 表格默认过滤列设置字段
 */
export const DEFAULT_FILTER_COLUMN = ['expand', 'selection']

/**
 * 是否根据headers->content-type自动转换数据格式
 */
export const TRANSFORM_REQUEST_DATA = true

/**
 * 全局图标前缀
 */
export const ICON_PREFIX = 'vi-'

/**
 * 财务API前缀
 */
export const FINANCE_API_PREFIX = '/barV2/finance'

/**
 * 企业微信appid
 */
export const CORP_ID = 'ww9f33ab05640664a7'

/**
 * 企业微信agentid
 */
export const AGENT_ID = '1000004'
